{
  "ariaLabelRightButton": "Scroll right",
  "ariaLabelLeftButton": "Scroll left"
}
